import { Button } from "@pushpress/pushpress-ui";
import { Plus, Users, UserPlus, ClipboardList } from "lucide-react";
import { useHistory } from "react-router-dom";
import { handleAddClick } from "../../helpers";
import { PeopleType, PEOPLE_TYPE } from "../../types";

export default function EmptyTable({ peopleType }: { peopleType: PeopleType }) {
  const history = useHistory();

  if (peopleType === PEOPLE_TYPE.LEADS) {
    return (
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-text-center">
        <div className="tw-text-neutral-400 tw-text-4xl tw-mb-4">
          <UserPlus className="tw-h-12 tw-w-12" />
        </div>
        <h4 className="tw-mb-2">No leads</h4>
        <p className="tw-text-neutral-500 tw-mb-6">
          Setup your lead form to get started, or add a lead.
        </p>
        <Button
          data-testid="add-lead-button"
          onClick={() => handleAddClick(peopleType)}
        >
          <Plus className="tw-mr-2 tw-h-4 tw-w-4" />
          Lead
        </Button>
      </div>
    );
  }

  if (peopleType === PEOPLE_TYPE.STAFF) {
    return (
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-text-center">
        <div className="tw-text-neutral-400 tw-text-4xl tw-mb-4">
          <ClipboardList className="tw-h-12 tw-w-12" />
        </div>
        <h4 className="tw-mb-2">No staff</h4>
        <p className="tw-text-neutral-500 tw-mb-6">Add staff to get started.</p>
        <Button
          data-testid="add-staff-button"
          onClick={() => handleAddClick(peopleType)}
        >
          <Plus className="tw-mr-2 tw-h-4 tw-w-4" />
          Staff
        </Button>
      </div>
    );
  }

  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-text-center">
        <div className="tw-text-neutral-400 tw-text-4xl tw-mb-4">
          <Users className="tw-h-12 tw-w-12" />
        </div>
        <h4 className="tw-mb-2">No members</h4>
        <p className="tw-text-neutral-500 tw-mb-6">
          Go to the migration assistant to get started, or add a member.
        </p>
        <div className="tw-flex tw-gap-4">
          <Button
            data-testid="migration-assistant-button"
            variant="outline"
            onClick={() => {
              history.push("/migration-assistant/");
            }}
          >
            Migration assistant
          </Button>
          <Button
            data-testid="add-member-button"
            onClick={() => handleAddClick(peopleType)}
          >
            <Plus className="tw-mr-2 tw-h-4 tw-w-4" />
            Member
          </Button>
        </div>
      </div>
    </>
  );
}
